import { render, staticRenderFns } from "./imageCarousel2.vue?vue&type=template&id=e2ecc848&"
import script from "./imageCarousel2.vue?vue&type=script&lang=js&"
export * from "./imageCarousel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2ecc848')) {
      api.createRecord('e2ecc848', component.options)
    } else {
      api.reload('e2ecc848', component.options)
    }
    module.hot.accept("./imageCarousel2.vue?vue&type=template&id=e2ecc848&", function () {
      api.rerender('e2ecc848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/imageCarousel2.vue"
export default component.exports